// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","mobile":"Home_mobile__50LLT","standard":"Home_standard__9prNh"};